import { render } from "./ContentFirst.vue?vue&type=template&id=52a8c9b0"
import script from "./ContentFirst.vue?vue&type=script&lang=js"
export * from "./ContentFirst.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/.pnpm/vue-loader@17.0.1_ceoavo7i67lvjzxxtqa4yhrx7m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__